//angular
import { Component, OnInit } from '@angular/core';
import { MetaService } from 'src/app/_core/services/meta.service';
//app
import { AppAnimations } from '../../../../../_shared/animations';



@Component({
  selector: 'app-security',
  templateUrl: './security.component.html',
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' }
})

export class SecurityComponent implements OnInit {
  resSuccess: boolean;
  isDataReady: boolean = false;

  constructor(
    public _meta: MetaService,
  ) { }

  ngOnInit() {
    setTimeout(() => {
      this.resSuccess = true;
      this.isDataReady = true;
    }, 400);
  }

  changeTwoFactorAuthentication(event){

    //API: imlement the method for call the api

    
  }

  
}
